import React, {memo, useEffect, useState} from "react";
import axios from "axios";
import moment from "moment";
import ScrollArea from "react-scrollbar";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Collapse,
    Icon,
    IconButton
} from "@material-ui/core";
import {ExpandMore} from "@material-ui/icons";
import Loading from "../../components/Loading";
import LightTooltip from "../../components/LigthTooltip";
import CustomButton from "../../components/CustomButton";


const Step3 = ({selectServiceId, selectedDay, selectSessions, setSelectSessions, setStep}) => {
    const [sessions, setSessions] = useState({});
    const [date, setDate] = useState(selectedDay);
    const [maxSessions, setMaxSessions] = useState(1);
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        axios({url: `/api/widget/date_sessions?id=${selectServiceId}&date=${date}`})
            .then(response => {
                const data = response.data.result;

                if(data) {
                    if(data.max_session_number_for_record && data.max_session_number_for_record > 1) {
                        setMaxSessions(data.max_session_number_for_record);
                    }

                    if(data.sessions) {
                        setSessions(data.sessions.length > 1 ?
                            data.sessions.reduce((acc, cur) => {
                                if(moment(cur.start).isBefore(moment(date).hour(6))) {
                                    acc.night = acc.night ? [...acc.night, cur] : [cur];
                                } else if(moment(cur.start).isBefore(moment(date).hour(12))) {
                                    acc.morning = acc.morning ? [...acc.morning, cur] : [cur];
                                } else if(moment(cur.start).isBefore(moment(date).hour(18))) {
                                    acc.day = acc.day ? [...acc.day, cur] : [cur];
                                } else {
                                    acc.evening = acc.evening ? [...acc.evening, cur] : [cur];
                                }

                                return acc;
                            }, {}) :
                            data.sessions.length ? {event: data.sessions[0]} : {}
                        );
                    }
                } else {
                    setErrors(['Что-то пошло не так...']);
                }

                setLoading(false);
            })
            .catch(e => {
                if(e.isAxiosError && e.response) {
                    if(e.response.data.errors) {
                        setErrors(Object.keys(e.response.data.errors).map(key => `Ошибка ${key}: ${e.response.data.errors[key]}`));
                    } else {
                        setErrors([`Ошибка ${e.response.status}: ${e.response.statusText}`]);
                    }
                } else {
                    setErrors(['Что-то пошло не так...']);
                }

                setLoading(false);
            });
    }, [selectServiceId, date]);

    const handleChangeDate = direction => {
        setDate(direction === 'next' ?
            moment(date).add(1, 'd').format('YYYY-MM-DD') :
            moment(date).subtract(1, 'd').format('YYYY-MM-DD')
        );
    };

    const handleSelect = session => {
        if(maxSessions > 1) {
            if(maxSessions > selectSessions.length) {
                setSelectSessions(selectSessions.find(item => item.id === session.id) ?
                    selectSessions.filter(item => item.id !== session.id) :
                    [...selectSessions, session]
                )
            }
        } else {
            setSelectSessions([session]);
            setStep(4);
        }
    };

    return loading ?
        <Loading/> :
        <div className="registration-for-service__step-3 step-3">
            <div className="step-3__title">
                <LightTooltip title="Назад">
                    <span>
                        <IconButton
                            aria-label="Previous"
                            disabled={moment(date).isSame(moment(), 'd')}
                            onClick={() => handleChangeDate('prev')}
                        >
                        <Icon>chevron_left</Icon>
                    </IconButton>
                    </span>
                </LightTooltip>
                <h4 className="step-3__title-date">
                    {moment(date).format('dddd DD MMMM')}
                </h4>
                <LightTooltip title="Вперед">
                    <IconButton
                        aria-label="Next"
                        onClick={() => handleChangeDate('next')}
                    >
                        <Icon>chevron_right</Icon>
                    </IconButton>
                </LightTooltip>
            </div>
            <h4 className="step-3__subtitle">
                {Object.keys(sessions).length ? 'Доступное время для записи' : 'Нет доступных сеансов'}
            </h4>
            <div className="step-3__content">
                <ScrollArea
                    className="step-3__wrap-scroll"
                    contentClassName="step-3__scroll"
                    verticalScrollbarStyle={{borderRadius: 6, width: 6, backgroundColor: '#aaa'}}
                    verticalContainerStyle={{borderRadius: 8, width: 8}}
                    horizontal={false}
                    smoothScrolling={true}
                >
                    {!errors.length ?
                        sessions.event ?
                            <button
                                className="step-3__btn"
                                disabled={sessions.event.resource}
                                onClick={() => handleSelect(sessions.event)}
                            >
                                {moment(sessions.event.start).format('HH:mm')}
                            </button> :
                            Object.keys(sessions).map(key =>
                                <Accordion className="step-3__accordion" key={key} defaultExpanded>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-label="Expand"
                                        aria-controls={`event-accordion-actions-${key}-content`}
                                        id={`event-accordion-actions-${key}-header`}
                                    >
                                        <span>
                                            {
                                                key === 'night' ? 'Ночь' :
                                                key === 'morning' ? 'Утро' :
                                                key === 'day' ? 'День' :
                                                'Вечер'
                                            }
                                        </span>
                                    </AccordionSummary>
                                    <AccordionDetails className="step-3__events">
                                        {sessions[key].map(session =>
                                            <button
                                                key={session.id}
                                                className={`step-3__btn${selectSessions.find(item => item.id === session.id) ? ' _active' : ''}`}
                                                disabled={session.resource}
                                                onClick={() => handleSelect(session)}
                                            >
                                                {moment(session.start).format('HH:mm')}
                                            </button>
                                        )}
                                    </AccordionDetails>
                                </Accordion>
                            ) :
                        <div className="registration-for-service__errors">
                            {errors.map((error, i) =>
                                <p key={`error-${i}`}>{error}</p>
                            )}
                        </div>
                    }
                </ScrollArea>
            </div>
            <div className="step-3__controls">
                <Collapse in={!!selectSessions.length}>
                    <p className={`step-3__controls-info${maxSessions === selectSessions.length ? ' _red' : ''}`}>
                        {maxSessions === selectSessions.length ?
                            'Выбрано максимально количество сеансов для записи' :
                            `Выбрано: ${selectSessions.length}`
                        }
                    </p>
                    <CustomButton
                        className="step-3__controls-btn"
                        onClick={() => setStep(4)}
                    >
                        Запись
                    </CustomButton>
                    <CustomButton
                        className="step-3__controls-btn"
                        bgColor="grey"
                        onClick={() => setSelectSessions([])}
                    >
                        Отмена
                    </CustomButton>
                </Collapse>
            </div>
        </div>
};

export default memo(Step3);